import useApi from 'hooks/useApi'
import { useQuery } from '@tanstack/react-query'

const useGetCarouselVideo = (uuid, enabled = true) => {

  const { apiFetch } = useApi();
  const url = `/carrusels/${uuid}/contents?hasBody=false`

  const getCarousel = () => {
    if (!uuid) return []
    
    return apiFetch({ url })
      .then( res => {
        const data = res.data.contents.map((video) => (
          { ...video, to:`community/${video.uuid}` }
        ))
        return data
      })
  }

  const options = {
    staleTime: 60000 * 30, // 30 min
    placeholderData: [],
    enabled
  }

  return useQuery(['video', uuid, 'lang'], getCarousel, options)
}

export default useGetCarouselVideo
